<template>
<div class="wrap talk">
		<header>
			<h1><a href="#" class="logo"></a></h1>
		</header>
		<div class="container">
			<main class="content">
				<article class="certification">
					<section class="txt return" v-if=" rs_data.prchStatCd === '040300' ">
						<p class="return-txt">판매취소 요청하신 제품에 대해<br><span>받으실 주소</span>를<br>입력해 주시기 바랍니다.</p>
					</section>
          			<section class="txt agree-bg" v-else-if=" rs_data.prchStatCd === '040400' ">
					</section>          
          			<section class="txt agree-bg" v-else>
					</section>          					
					<section class="return-wrap" v-if=" rs_data.prchStatCd === '040300' " >
						<div class="con-box">
							<h2>판매취소 요청 제품</h2>
							<div v-if="cate01Num === '4' || rs_data.cate01Num === '660' " class="item row row_jsb" >
								<span class="item-tit">휴대폰 종류</span>
								<span class="item-con taR">{{rs_data.ptnmNm}}</span>
							</div>
							<div v-else class="item row row_jsb">
								<span class="item-tit">종류</span>
								<span class="item-con taR">{{rs_data.cate01Nm}}</span>
							</div>
						</div>
						<div class="con-box">
							<h2>반품 받으실 주소</h2>
							<div class="form-wrap">
								<dl class="row row_jsb row_ac">
									<dt>주소</dt>
									<dd class="psr">
										<input readonly  v-model="rs_data.cstmPostNum"  type="text" class="t-input" placeholder="우편번호">
										<button @click="showApi" class="search_btn"><i class="xi-search"></i></button>
									</dd>
								</dl>
								<dl class="row row_jsb row_ac">
									<dt></dt>
									<dd><input readonly v-model="rs_data.cstmBscAddr" type="text"  class="t-input" placeholder="주소"></dd>
								</dl>
								<dl class="row row_jsb row_ac">
									<dt></dt>
									<dd><input type="text" class="t-input"  v-model="rs_data.cstmDtlAddr"  placeholder="상세주소"></dd>
								</dl>
							</div>
						</div>
						<div class="con-box ag">
							<div class="agree-wrap">
								<div class="check-wrap row pad_t20">
									<input type="checkbox" class="checkbox" id="check-02" name="ChkAgree">
									<label for="check-02"></label>
									<span class="agree-chk">개인정보 수집 및 이용 동의</span>
								</div>
								<div class="agree-con" >
									수집항목 : 주소<br>
									이용목적 : 반품 요청 제품에 대한 배송지 주소로 활용<br>
									보유기간 : 반품 완료 후 3년<br>
								</div>
							</div>
						</div>
					</section>
					<div class="btn-wrap" v-if=" rs_data.prchStatCd === '040300' ">
						<a href="javascript:void(0);" class="talk-btn btn-black" @click.stop.prevent="eupReturCncl()">판매취소 요청 하기</a>
					</div>

          			<section v-if=" rs_data.prchStatCd === '040400' ">
						<div class="box row row_c row_jsc">
							<span><i class="xi-check"></i></span>
							<p>판매취소 요청이 처리되었습니다.</p>
						</div>
					</section>					
          			<section v-else-if=" rs_data.prchStatCd != '040300' &&  rs_data.prchStatCd != '040400'">
						<div class="box row row_c row_jsc">
							<span><i class="xi-check"></i></span>
							<p>판매취소 요청이 가능한 상태가 아닙니다.</p>
						</div>
					</section>										


          			<section class="mar_b20" v-if=" rs_data.prchStatCd === '040400' ">
						<div class="con-box">
							<h2>판매취소 요청 제품</h2>
							<div v-if="rs_data.cate01Num === '4' || rs_data.cate01Num === '660' " class="item row row_jsb" >
								<span class="item-tit">휴대폰 종류</span>
								<span class="item-con taR">{{rs_data.ptnmNm}}</span>
							</div>
							<div v-else class="item row row_jsb">
								<span class="item-tit">종류</span>
								<span class="item-con taR">{{rs_data.cate01Nm}}</span>
							</div>
						</div>
						<div class="con-box">
							<h2>판매취소 요청 정보</h2>
							<div class="item row row_jsb">
								<span class="item-tit">이름</span>
								<span class="item-con taR">{{rs_data.cstmNm}}</span>
							</div>
							<div class="item row row_jsb">
								<span class="item-tit">연락처</span>
								<span class="item-con taR">{{rs_data.cstmClphNum}}</span>
							</div>
							<div class="item row row_jsb">
								<span class="item-tit">주 소</span>
								<span class="item-con taR">{{rs_data.returPstNo}} <br> {{rs_data.returAddr}} <br> {{rs_data.returDtlAddr}}</span>
							</div>
						</div>
					</section>          

				</article>
				<div class="cs-center row row_ac row_jsc">
					<span class="qa">고객센터 문의 </span>
					<span><a href="#" class="en phone">1877-5446</a></span>
				</div>
			</main>
		</div>
		<input type="hidden" v-model="rs_data.prchNum">
		<input type="hidden" v-model="rs_data.prchStatCd">
    	<post-code-popup @popup-complete="handleCompletePopupByAddress" />	
	</div>
</template>

<!--
<script src="https://spi.maps.daum.net/imap/map_js_init/postcode.v2.js"></script>
<script src="//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js"></script>
-->

<script>

import Vue from 'vue'
import AppConfig from '@/config'
import Utils from '@/modules/utils'
import PostCodePopup from '@/views/purchase/cmm/PostCodePopup'


import '@/assets/js/postcode/Postcode'

const $ = window.$

export default {
  name: 'EupReturCncl',
  components: {PostCodePopup},
  data: () => ({
    AppConfig: AppConfig,
    ptnmNm : '',  
    cate01Num : '',   // 4 -> 스마트폰, 660 -> 없는 모델매각신청
    cate01Nm : '',
    prchStatCd : '040400',   
    rs_data : [],
	purchaseModel : [],
    parms: {
      ordNum : '',
    }
  }),
  computed: {

  },
  mounted() {
    this.saleAgrmCnclInit()
  },

  methods: {
    async saleAgrmCnclInit () {
      const params = {
        ordNum : this.$route.query.ordNum,
        state   : this.$route.query.state,
      }
      console.log('params ==> {}', params)
      const rtn = await Vue.httpClient.get('/api/purchase/pcs/mgmt/public/ord-num', {params})
        .then(res => {
          if (res.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
            if (res.data.result) {
              console.log(res.data.result)
              this.rs_data = res.data.result 
			  this.rs_data.cstmClphNum = Utils.phoneFomatter(this.rs_data.cstmClphNum) 
            } else {
              Vue.Alert.alert("매입정보가 없습니다!")  
            }
          } else {
            Vue.Alert.alert("통신 오류 입니다.")
          }
        })
    },    

	openDaumPostcode() {
		new window.daum.Postcode({
			oncomplete: (data) => {
				console.log(data)
				this.rs_data.cstmPostNum = data.zonecode
				this.rs_data.cstmBscAddr = data.address
				this.rs_data.cstmDtlAddr = ''
			}
		}).open();		
	}  ,
	handleCompletePopupByAddress (data) {
       	console.log(data);
    },
    async handlePopupByAddress () {
		console.log('postCode')
      	this.$modal.show('postCodePopup')
    },	  
	async eupReturCncl () {   // 판매취소
		//test data
		//this.rs_data.cstmPostNum = '12345'
		//this.rs_data.cstmBscAddr = '서울시 영등포구 여의도동'
		//this.rs_data.cstmDtlAddr = '메롱메롱'
	
		if( this.rs_data.cstmPostNum == '' || this.rs_data.cstmBscAddr == '' || this.rs_data.cstmDtlAddr == ''){
			alert("반품 받으실 주소를 입력해주세요");
			return;
		}
		// 약관 
		var isChk = true;
		var arr_Chk = document.getElementsByName("ChkAgree");
		for(var i=0;i<arr_Chk.length;i++){
			if(arr_Chk[i].checked == false) {
				isChk = false;
				break;
			}
		}	
		if(!isChk){
			alert("개인정보 수집 및 이용동의하셔야 신청하실수 있습니다.");
			return false;
		}
     	const isTrue = await this.$Alert.confirm("판매취소 요청을 하시겠습니까?")
      	if (!isTrue) return		

		const { data } = await this.$http.post('/api/purchase/pcs/mgmt/public/eupRetur-cncl', this.rs_data)
		if (data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
			this.$Alert.alert(data.result.talkMobileMsg).then(() => {
				this.$router.go()
			})
		} else {
			this.$Alert.alert("판매취소 요청을 실패하였습니다!")
        }
    },	 
	
	showApi() { 
		new window.daum.Postcode({ 
			oncomplete: (data) => { 
				// 팝업에서 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분. 
				// 도로명 주소의 노출 규칙에 따라 주소를 조합한다. 
				// 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다. 
				let fullRoadAddr = data.roadAddress; // 도로명 주소 변수 
				let extraRoadAddr = ''; // 도로명 조합형 주소 변수 

				// 법정동명이 있을 경우 추가한다. (법정리는 제외) 
				// 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다. 
				if(data.bname !== '' && /[동|로|가]$/g.test(data.bname)){ 
					extraRoadAddr += data.bname; 
				} 

				// 건물명이 있고, 공동주택일 경우 추가한다. 
				if(data.buildingName !== '' && data.apartment === 'Y'){ 
					extraRoadAddr += (extraRoadAddr !== '' ? ', ' + data.buildingName : data.buildingName); 
				} 

				// 도로명, 지번 조합형 주소가 있을 경우, 괄호까지 추가한 최종 문자열을 만든다. 
				if(extraRoadAddr !== ''){ 
					extraRoadAddr = ' (' + extraRoadAddr + ')'; 
				} 

				// 도로명, 지번 주소의 유무에 따라 해당 조합형 주소를 추가한다. 
				if(fullRoadAddr !== ''){ 
					fullRoadAddr += extraRoadAddr; 
				} 

				// 우편번호와 주소 정보를 해당 필드에 넣는다. 
				this.rs_data.cstmPostNum = data.zonecode; 
				//5자리 새우편번호 사용 
				this.rs_data.cstmBscAddr = fullRoadAddr; 
				this.rs_data.cstmDtlAddr = ''
			} 
		}).open()		
	},
	
	phoneFomatter(rowData){
		return Utils.phoneFomatter(rowData.clphNum)
	},
  }
}
</script>



// WEBPACK FOOTER //
// src/views/purchase/EupReturCncl.vue